import { MOCK_SUPPORTER_MIXED_COMMITMENTS } from './mocks/supporters.ts';

const nextPublicUseMockSupporter =
  typeof process !== 'undefined'
    ? process.env.NEXT_PUBLIC_USE_MOCK_SUPPORTER
    : undefined;

export const QUERY_KEYS = {
  dataPrimerReadOnly: 'dataPrimer',
  supporterPaymentSettings: 'supporterPaymentSettings',
  supporterDataStatus: 'supporterDataStatus',
  supporterPaymentMethods: 'supporterPaymentMethods',
  supporterCommitments: 'supporterCommitments',
  supporterDepartureSummary: 'supporterDepartureSummary',
  supporterGivingTotals: 'supporterGivingTotals',
  supporterAddress: 'supporterAddress',
  supporterGivingHistory: 'supporterGivingHistory',
  supporterPledges: 'supporterPledges',
  supporterTaxReceipts: 'supporterTaxReceipts',
  supporterDetails: 'supporterDetails',
  supporterGiftLimits: 'supporterGiftLimits',
  supporterPreferredUsername: 'supporterPreferredUsername',
  supporterContacts: 'supporterContacts',
  supporterContactPreferences: 'supporterContactPreferences',
  supporterRecentLetters: 'supporterRecentLetters',
  supporterRecentTransactions: 'supporterRecentTransactions',
  supporterVolunteerEvents: 'supporterVolunteerEvents',
  supporterWritingPreferences: 'supporterWritingPreferences',
};

export const MUTATION_KEYS = {
  makeAPaymentAdd: 'makeAPaymentAdd',
  paymentMethodRemove: 'paymentMethodRemove',
  commitmentPaymentPlanUpdate: 'commitmentPaymentPlanUpdate',
  departureSubUpdate: 'departureSubUpdate',
  addressUpdate: 'addressUpdate',
  contactInfoUpdate: 'contactInfoUpdate',
  preferredUsernameUpdate: 'preferredUsernameUpdate',
  passwordUpdate: 'passwordUpdate',
};

export const MOCK_SUPPORTER =
  nextPublicUseMockSupporter && nextPublicUseMockSupporter !== 'false'
    ? MOCK_SUPPORTER_MIXED_COMMITMENTS
    : null;
